import React from "react";
import {
	Grid,
	Typography,
} from "@mui/material";

export const PageHeading = ({
	pageTitle,
	children,
	sx,
}) => {

	return (
		<Grid 
			item
			container
			xs={6}
			sm={8}
			lg={12}
			xl={12}
			mb={0}
			alignItems="center"
			sx={{ ...sx }}
		>
			<Grid item xs="auto" mr={1}>
				<Typography component="h1" variant="h5">
					{pageTitle}
				</Typography>
			</Grid>
			{children}
		</Grid>
	);
    
};
  